var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 12.067c0 5.966 4.333 10.927 10 11.933v-8.667h-3V12h3V9.333c0-3 1.933-4.666 4.667-4.666.866 0 1.8.133 2.666.266V8H16.3c-1.467 0-1.8.733-1.8 1.667V12h3.2l-.533 3.333H14.5V24c5.667-1.006 10-5.966 10-11.933C24.5 5.43 19.1 0 12.5 0S.5 5.43.5 12.067Z",
    fill: "currentcolor"
  })));
};
export default SvgFacebook;